import type { Client } from '@urql/core'

import { graphql } from 'app/generated/gql'
import type { NoteTemplate, NoteTemplateListResult } from 'app/generated/graphql'
import type { ListParams } from './EntityStore'
import { EntityStore } from './EntityStore'

const NOTE_TEMPLATE_FIELDS = `version createdDate updatedDate id orgId workspaceId name body`

const LIST_QUERY = graphql(`
  query NoteTemplates($search: String, $pagination: PaginationInput, $sort: SortInput) {
    noteTemplates(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        version
        createdDate
        updatedDate
        id
        orgId
        workspaceId
        name
        body
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query NoteTemplate($id: ID!) {
    noteTemplate(id: $id) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      name
      body
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateNoteTemplate($input: CreateNoteTemplateInput!) {
    createNoteTemplate(input: $input) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      name
      body
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateNoteTemplate($id: ID!, $input: UpdateNoteTemplateInput!) {
    updateNoteTemplate(id: $id, input: $input) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      name
      body
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteNoteTemplate($id: ID!) {
    deleteNoteTemplate(id: $id)
  }
`)

/** The whole workspace's templates in one page, newest edit first. */
export const NOTE_TEMPLATE_LIST_PARAMS: ListParams = {
  pagination: { page: 0, limit: 200 },
  sort: { field: `updatedDate`, direction: `DESC` },
}

export type NoteTemplateInput = { name: string; body: string }

export class NoteTemplateStore extends EntityStore<
  NoteTemplate,
  NoteTemplateListResult,
  typeof CREATE_MUTATION,
  typeof UPDATE_MUTATION
> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `NoteTemplate`,
      extractList: (data: any) => data.noteTemplates,
      extractOne: (data: any) => data.noteTemplate,
      extractMutated: (data: any) => data.updateNoteTemplate ?? data.createNoteTemplate,
    })
  }
}
